<!--
  Marker Component, displaying a round marker to indicate the annotation positions
  On click, the corresponding annotation will be selected and displayed
  The Indicator is annotation?.ranking
-->
@if (annotation(); as annotation) {
  @if (!isAnnotationHidden()) {
    @if (positionData(); as data) {
      <div
        class="marker single-annotation-card"
        [style.--top.px]="data.top - markerSize / 2"
        [style.--left.px]="data.left - markerSize / 2"
        [style.--scale]="data.behind ? 0.75 : 1"
        [style.z-index]="data.z"
        [style.opacity]="data.behind ? 0.25 : 1"
        (click)="selectAnnotation(annotation)"
      >
        {{ annotation.ranking }}
      </div>
    }
  }
}
